import { Offer } from "../types/offer";
import { OfferScopeOfWorkSelect } from "./offer-scope-of-work-select";
import {
  OfferScopeOfWorkAddDialog,
  OfferScopeOfWorkAddDialogConfig,
} from "./offer-scope-of-work-add-dialog";
import { OfferScopeOfWorkDeleteDialog } from "./offer-scope-of-work-delete-dialog";

/**
 * OfferScopeOfWorkToolbar selects, adds and deletes the scope of works of
 * the offer. selectedId is the selected one; onSelect receives the one
 * selected or added, and no id after a delete. The last scope of work
 * cannot be deleted. deleteDescription replaces the description of the
 * delete confirmation.
 */
export function OfferScopeOfWorkToolbar({
  offer,
  addDialogConfig,
  selectedId,
  onSelect,
  deleteDescription,
  disabled,
}: {
  offer: Offer;
  addDialogConfig: OfferScopeOfWorkAddDialogConfig;
  selectedId: string | undefined;
  onSelect: (id?: string) => void;
  deleteDescription?: string;
  disabled: boolean;
}) {
  return (
    <div className="flex items-center gap-2">
      <div className="min-w-0 flex-1">
        <OfferScopeOfWorkSelect
          scopeOfWorks={offer.scopeOfWork}
          value={selectedId}
          onValueChange={onSelect}
        />
      </div>
      <OfferScopeOfWorkAddDialog
        offer={offer}
        config={addDialogConfig}
        onCreated={onSelect}
        disabled={disabled}
      />
      <OfferScopeOfWorkDeleteDialog
        offerId={offer.id}
        scopeOfWorkId={selectedId}
        onDeleted={() => onSelect(undefined)}
        description={deleteDescription}
        disabled={disabled || offer.scopeOfWork.length <= 1}
      />
    </div>
  );
}
